import {each} from 'underscore';
import xhr from './Xhr';

export default class WorkBookFormSubscriber {
    constructor() {
        this.CLASSES = {
            form_wrapper: 'js-workbook-order-form-wrapper',
            workbook_form_wrapper: 'js-workbook-form-wrapper',
            trigger: {
                change: 'js-workbook-subscriber'
            }
        };

        this.touchEvent = 'click' in window ? 'touchend' : 'change';

        this.INPUTNAMES = {
            wantsWorkBook: 'will_workbook_order[wantsWorkBook]',
            company: 'will_workbook_order[deliveryAddress][company]',
            vat: 'will_workbook_order[deliveryAddress][vat]',
            street: 'will_workbook_order[deliveryAddress][street]',
            postalCode: 'will_workbook_order[deliveryAddress][postalCode]',
            city: 'will_workbook_order[deliveryAddress][city]',
            country: 'will_workbook_order[deliveryAddress][country]',
            token: 'will_workbook_order[_token]'
        };

        this.addWorkBookEventListener();
    }

    addWorkBookEventListener() {
        each(document.querySelectorAll(`.${this.CLASSES.trigger.change}`),
            (el) => {
                el.addEventListener(this.touchEvent,
                    (event) => this.changeForm(event));
            });
    }

    changeForm(event) {
        event.preventDefault();

        const checkbox = event.target;
        const form = checkbox.closest('form');

        const url = form.getAttribute('action');

        if (url) {
            // Build data params
            let data = '';
            each(this.INPUTNAMES, (inputField) => {
                const el = form.querySelector(`[name="${inputField}"]`);
                if (el === null) {
                    return;
                }

                let value;

                if (el.type === 'checkbox') {
                    if (el.checked) {
                        value = el.checked;
                    }
                } else {
                    value = form.querySelector(`[name="${inputField}"]`).value;
                }
                if (value) {
                    data += `${inputField}=${value}&`;
                }
            });

            xhr.post(url, data).then((request) => {
                const response = request.responseText;
                const wrapper = document.querySelectorAll(`.${this.CLASSES.workbook_form_wrapper}`)[0];

                if (typeof wrapper !== 'undefined') {
                    // Create invisible container;
                    const tempContainerId = 'temp-container';
                    const tempContainer = document.createElement('div');
                    tempContainer.id = tempContainerId;
                    tempContainer.style.setProperty('display', 'none');
                    document.body.appendChild(tempContainer);

                    // Append items into invisible container;
                    tempContainer.insertAdjacentHTML('beforeend', response);

                    const node = Array.prototype.slice.call(document.querySelectorAll(`#${tempContainerId} .${this.CLASSES.workbook_form_wrapper}`))[0];
                    wrapper.innerHTML = node.innerHTML;
                    wrapper.classList.toggle('workbook-form-wrapper--hidden');
                    document.body.removeChild(tempContainer);
                }
            });
        }
    }
}



// WEBPACK FOOTER //
// ./src/Will/WebsiteBundle/Resources/ui/js/WorkBookFormSubscriber.js